// 气象站点Id
export const STATION_ID = '57846'
// 国家站
// 经度
export const LON = 110.155075
// 纬度
export const LAT = 26.723622
export const ADMINCODE = 430527

export const WECHAT_APPID = 'wxfd1243fbf342326b'
